var map = {
  "./ADMINISTRATIVO.svg": "691342",
  "./ANALISE.svg": "378993",
  "./APAC.svg": "185761",
  "./BUSCA_ATIVA.svg": "704806",
  "./CONECTA.svg": "370211",
  "./EEG.svg": "982795",
  "./ELETROCARDIOGRAFIA.svg": "546789",
  "./ESPIROMETRIA.svg": "548112",
  "./ESTOMATO.svg": "399512",
  "./EXAMES.svg": "23743",
  "./GESTAOPACS.svg": "959796",
  "./HELPDESK.svg": "139428",
  "./MENSAGENS.svg": "867555",
  "./OAUTH2.svg": "801463",
  "./OXIGENOTERAPIA.svg": "56764",
  "./POLISSONOGRAFIA.svg": "98004",
  "./RSE.svg": "261808",
  "./TELEATENDIMENTO.svg": "69248",
  "./TELECONSULTORIAS.svg": "26570",
  "./TELEDERMATO.svg": "307446",
  "./TELEEDUCACAO.svg": "828753",
  "./TFD.svg": "526724",
  "./TFDPASSAGENS.svg": "521221"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 722171;
